<script setup lang="ts">
import { computed, inject, reactive, ref } from 'vue'
import { getImageUrl } from '@/utils'
// components
import itemPanel from './itemPanel.vue'
// types
import { PopupInfo } from '@/components/GlobalUgcPopup/types'

const isShowUgcPopup = inject('isShowUgcPopup', ref(false))
const globalUgcPopupData = inject<PopupInfo | any>('globalUgcPopupData', reactive({}))
const touchSlideStyle = computed(() => {
  if (!globalUgcPopupData.touchSlide) return ''
  if (globalUgcPopupData.touchSlide === 'left') {
    return 'ml58'
  } else if (globalUgcPopupData.touchSlide === 'right') {
    return 'ml236'
  }
})

// 点击 center-con，阻止事件冒泡
const conClick = (e: Event) => {
  e.stopPropagation()
}

// 点击 pop-center（遮罩层），关闭弹窗
const popUpCLick = () => {
  isShowUgcPopup.value = false
}
</script>

<template>
  <div class="pop-center" @click="popUpCLick">
    <div class="center-con" :style="{ top: globalUgcPopupData.positionTop + 'px' }" @click="conClick">
      <GlobalImage
        class="direction-icon no-wechat-menu"
        :src="getImageUrl('public', 'top_slide.png')"
        :class="[touchSlideStyle]"
        v-if="globalUgcPopupData.showDirection === 'top'"
        alt=""
      ></GlobalImage>
      <div class="pop-con" :class="{ mt6: globalUgcPopupData.showDirection === 'top' }">
        <itemPanel
          v-for="(item, i) in globalUgcPopupData.popupData[0]"
          :key="i"
          :item="item"
          :show-line="globalUgcPopupData.popupData[0].length > 1 && i < globalUgcPopupData.popupData[0].length - 1"
          :user="globalUgcPopupData.actionUserInfo"
        />
      </div>
      <GlobalImage
        class="direction-icon no-wechat-menu mt1"
        :src="getImageUrl('public', 'bottom_slide.png')"
        :class="[touchSlideStyle]"
        v-if="globalUgcPopupData.showDirection === 'bottom'"
        alt=""
      ></GlobalImage>
    </div>
  </div>
</template>

<style scoped lang="scss">
.pop-center {
  width: 100%;
  height: 100vh;

  .mt6 {
    margin-top: -6px;
  }

  .center-con {
    min-height: 200px;
    overflow: hidden;
    position: relative;

    .direction-icon {
      width: 23px;
      height: 39px;

      &.ml58 {
        margin-left: 58px;
      }

      &.ml236 {
        margin-left: 236px;
      }

      &.mt1 {
        margin-top: -1px;
      }
    }

    .pop-con {
      width: 284px;
      background-color: #ffffff;
      border-radius: 12px;
      padding: 0 15px;
    }
  }
}
</style>
